import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-snack-bar',
  templateUrl: './success-snack-bar.component.html',
  styleUrls: ['./success-snack-bar.component.css']
})
export class SuccessSnackBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
